import React, { useRef, useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import { apiPost, apiPut } from "../../../utils/apiFetch";
import OButton from "components/reusable/OButton";
import { useNavigate, useLocation } from "react-router-dom";
import apiPath from "../../../utils/apiPath";
import { apiGet } from "../../../utils/apiFetch";
import useToastContext from "hooks/useToastContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OFile from "components/reusable/OFile";
import { mobileNumber, onlyNumbers, validationRules } from "utils/constants";
const EditExpert = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [profilePic, setProfilePic] = useState(location?.state?.images || null);
  const [addMerchantLoading, setAddMerchantLoading] = useState(false);
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [editData, setEditData] = useState(location.state);
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {},
  });

  const handleFileChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(image);
    if (isValidImage) {
      setProfilePic(image);
    } else {
      setProfilePic(null);
    }
  };

  const validateFiles = (profilePic) => {
    let picError = "";
    const supportedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!isEmpty(supportedTypes.includes(profilePic.type))) {
      picError = "Only jpeg, jpg and png are supported.";
    }
    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError("");
      return true;
    }
  };

  const getBack = () => {
    setRedirect(true);
    navigate("/consultation-manager", {state: { from: 'expert'}});
  };

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      setCategories(response?.docs);
    }
  };

//   const getSubCategories = (categoryId) => {
//     const category = categories.filter((item) => {
//       return item?._id === categoryId;
//     });
//     setSubCategories(category[0]?.subcategories);
//   };
  useEffect(() => {
    getCategories();
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue("name", editData.name ?? "");
      setValue("categoryId", editData?.category ?? "");
      setValue("experience", editData?.experience ?? "");
      setValue("whatsapp", editData?.whatsAppNumber ?? "");
    }
  }, [editData]);

//   useEffect(() => {
//     getSubCategories(editData?.category, categories);
//   }, [editData, categories.length]);

  const onSubmit = async (data) => {
    try {
        const path = apiPath.expertEdit + "/" + location?.state?._id;
        const formData = new FormData();
        formData.append("name", data.name);
        formData.append("category", data.categoryId);
        formData.append("experience", data.experience);
        formData.append("whatsAppNumber", data?.whatsapp);
        formData.append("image", profilePic);
        const result = await apiPut(path, formData);
        if (result?.data?.success) {
          setRedirect(true);
          notification.success(result.data.message);
        } else {
          notification.error(result.data.message);
        }
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
  };

  if (is_redirect) {
    return navigate("/consultation-manager", {state: { from: 'expert'}});
  }

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          {t("EDIT_EXPERT")}
        </h2>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="name"
                  id="name"
                  maxLength={51}
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("name", {
                    required: t("VALIDATION_NAME_REQUIRED"),
                    pattern: {
                      value: validationRules.characters,
                      message: t("INVALID_NAME")
                    },
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_NAME_MIN_LENGTH")
                        : val.length > 50
                        ? t("VALIDATION_NAME_MAX_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("name", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="name"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_Expert_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.name?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="experience"
                  id="experience"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  onKeyDown={(e) => onlyNumbers(e)}
                  maxLength={2}
                  {...register("experience", {
                    required: t("VALIDATION_EXPERIENCE_REQUIRED"),
                    pattern: {
                      value: validationRules.numbers,
                      message: t("EXPERIENCE_VALIDATION")
                    },
                    // validate: (value) => {
                    //   const val = value.trim();
                    //   return val.length < 3
                    //     ? t("VALIDATION_AUTHOR_MIN_LENGTH")
                    //     : val.length > 30
                    //     ? t("VALIDATION_AUTHOR_MAX_LENGTH")
                    //     : true;
                    // },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("experience", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="experience"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_EXPERIENCE")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.experience?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="categoryId"
                  name="categoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("categoryId", {
                    required: t("VALIDATION_SELECT_CATEGORY"),
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_CATEGORY")}
                  </option>
                  {categories &&
                    categories.length !== 0 &&
                    categories?.map(({ title, _id }) => (
                      <option key={_id} value={_id}  selected={_id === editData?.category}>
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="name"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORY")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.categoryId?.message} />
              </div>
            </div>
            <div className="mb-6">
            <div className="relative z-0 mb-6 w-full group">
                <input
                  type="number"
                  name="whatsapp"
                  id="whatsapp"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  onKeyDown={(e) => mobileNumber(e)}
                  maxLength={16}
                  {...register("whatsapp", {
                    required: t("VALIDATION_WHATSAPP_NUMBER_REQUIRED"),
                    validate: (value) => {
                    //   const val = value.trim();
                      return value.length < 7
                        ? t("VALIDATION_WHATSAPP_NUMBER_MIN_LENGTH")
                        : value.length > 15
                        ? t("VALIDATION_WHATSAPP_NUMBER_MAX_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("whatsapp", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="whatsapp"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_WHATSAPP_NUMBER")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.whatsapp?.message} />
              </div>
            </div>

            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
              <div className="text-center">
                <OButton
                  label={t("O_EDIT")}
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="flex">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                Upload Profile
              </h3>
              {/* <span className="text-red-500">*</span> */}
            </div>

            {!profilePic ? (
              <div
                id="FileUpload"
                className="relative mb-5.5 block w-full cursor-pointer appearance-none rounded border-2 border-dashed border-primary bg-gray py-5 px-4 dark:bg-meta-4 sm:py-7.5"
              >
                <input
                  type="file"
                  accept="image/png, image/jpg, image/jpeg"
                  name="image"
                  ref={profilePicRef}
                  onChange={handleFileChange}
                  className="absolute inset-0 z-50 m-0 h-full w-full cursor-pointer p-0 opacity-0 outline-none"
                />
                <div className="flex flex-col items-center justify-center space-y-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-stroke bg-white dark:border-strokedark dark:bg-boxdark">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                        fill="#3C50E0"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                        fill="#3C50E0"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                        fill="#3C50E0"
                      ></path>
                    </svg>
                  </span>
                  <p className="font-medium text-sm">
                    <span className="text-primary">Click to upload</span>
                  </p>
                </div>
              </div>
            ) : (
              <div className="relative">
                <button
                  title="Close"
                  className=" z-10 text-white rounded-full bg-red-500 hover:text-red-500 hover:bg-white text-3xl leading-none font-extralight outline-none focus:outline-none absolute top-2 right-[12px] w-[40px] h-[40px]"
                  onClick={() => setProfilePic(null)}
                >
                  ×
                </button>
                <OImage
                //   type={profilePic?.type}
                  src={typeof profilePic === 'object' ? URL.createObjectURL(profilePic) : profilePic}
                  fallbackUrl="/images/imagesBanner.png"
                    className="w-full h-full border relative"
                  alt=""
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditExpert;
